export default "__VITE_ASSET__b2d8524d__"